"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./onePosFixture"), exports);
__exportStar(require("./offerTemplatesFixture"), exports);
__exportStar(require("./bookingOrdersFixtures"), exports);
__exportStar(require("./ordersFixtures"), exports);
__exportStar(require("./bookingTemplateOfferFixture"), exports);
__exportStar(require("./bookingMenusFixtures"), exports);
__exportStar(require("./newsFixtures"), exports);
__exportStar(require("./brandFixtures"), exports);
__exportStar(require("./holdingFixtures"), exports);
__exportStar(require("./checkEmailExistFixtures"), exports);
__exportStar(require("./userHoldingViewFixtures"), exports);
__exportStar(require("./offerSlotsFixture"), exports);
__exportStar(require("./checkEmailExistFixtures"), exports);
__exportStar(require("./checkTablesAvailabilityFixture"), exports);
__exportStar(require("./offerFixture"), exports);
__exportStar(require("./historicalFixtures"), exports);
__exportStar(require("./ordersListFixtures"), exports);
__exportStar(require("./pickupPointsFixture"), exports);
__exportStar(require("./userLastUsedPickupPointFixture"), exports);
__exportStar(require("./upsertOrderFixtures"), exports);
__exportStar(require("./epointageFixture"), exports);
